module.exports = __webpack_public_path__ + "static/media/ana.ecd8e650.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/ana.jpg
// module id = 723
// module chunks = 0